import * as React from "react";
const SvgUpload = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 10,
	height: 12,
	viewBox: "0 0 10 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0.333336 11.6666H9.66667V10.3333H0.333336V11.6666ZM0.333336 4.99992H3V8.99992H7V4.99992H9.66667L5 0.333252L0.333336 4.99992Z",
	fill: "#9196A1"
}));
export default SvgUpload;
